import React, { useState } from 'react';

import CoursesAPI from '../../course-api';
import Button from '../../../../components/common/Button';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Alert from '../../../../components/common/Alert';
import CourseSummarySection from './summary';
import ConfirmationModal from '../../../ClientContainer/statusModal';
import Spinner from '../../../../components/common/Spinner';

const createCourseSlug = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');



const normalizeInstitutionForPayload = (institution, institutionsList = []) => {
  if (!institution) {
    return institution;
  }

  if (typeof institution === 'object') {
    const normalizedName = institution.name || institution.value || institution.label || '';
    let resolvedId = institution.id;

    if (
      (resolvedId === undefined ||
        resolvedId === null ||
        resolvedId === '') &&
      Array.isArray(institutionsList) &&
      institutionsList.length > 0
    ) {
      const normalizedNameLower = normalizedName
        ? normalizedName.toLowerCase().trim()
        : '';

      const fallbackInstitution = institutionsList.find((inst) => {
        const instName = inst.name ? inst.name.toLowerCase().trim() : '';
        const instValue = inst.value ? inst.value.toLowerCase().trim() : '';
        const instLabel = inst.label ? inst.label.toLowerCase().trim() : '';

        return (
          (instName && instName === normalizedNameLower) ||
          (instValue && instValue === normalizedNameLower) ||
          (instLabel && instLabel === normalizedNameLower)
        );
      });

      if (fallbackInstitution) {
        resolvedId = fallbackInstitution.id;
      }
    }

    const parsedId =
      resolvedId !== undefined &&
      resolvedId !== null &&
      resolvedId !== '' &&
      !Number.isNaN(Number(resolvedId))
        ? Number(resolvedId)
        : resolvedId;

    return {
      ...institution,
      id: parsedId,
      name: normalizedName,
      value: institution.value || normalizedName,
      logo: institution.logo,
    };
  }

  const match = institutionsList.find((inst) => {
    if (Number(inst.id) === Number(institution)) {
      return true;
    }

    if (typeof institution === 'string') {
      const normalizedInstitutionName = institution.toLowerCase().trim();
      const instName = inst.name ? inst.name.toLowerCase().trim() : '';
      const instValue = inst.value ? inst.value.toLowerCase().trim() : '';
      const instLabel = inst.label ? inst.label.toLowerCase().trim() : '';

      return (
        instName === normalizedInstitutionName ||
        instValue === normalizedInstitutionName ||
        instLabel === normalizedInstitutionName
      );
    }

    return false;
  });

  if (match) {
    const normalizedName = match.name || match.value || match.label || '';

    return {
      ...match,
      id:
        match.id !== undefined && match.id !== null ? Number(match.id) : match.id,
      name: normalizedName,
      value: match.value || normalizedName,
      logo: match.logo,
    };
  }

  return institution;
};

const CourseSummary = ({
  course,
  institutions,
  pillars,
  onPrev,
  mode = 'create',
  setInstitutions,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [messageAlert, setMessageAlert] = useState(null);
  const history = useHistory();

  const modalOpen = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };
  const renderTitle = mode === 'create' ? 'Crear nuevo curso' : 'Editar curso';

  const addCourse = async (payload) => {
    setSubmitting(true);
    return await CoursesAPI.addCourse(payload)
      .then(() => {
        setMessageAlert({
          type: 'success',
          message: 'Curso creado exitosamente',
        });
        setTimeout(() => history.push('/cursos'), 3000);
      })
      .catch((error) => {
        setMessageAlert({
          type: 'error',
          message: error?.data?.message || 'Error al crear el curso',
        });
      })
      .finally(() => setSubmitting(false));
  };

  const updateCourse = async (payload) => {
    setSubmitting(true);
    return await CoursesAPI.updateCourse(payload)
      .then(() => {
        setMessageAlert({
          type: 'success',
          message: 'Curso actualizado exitosamente',
        });
        setTimeout(() => history.push('/cursos'), 3000);
      })
      .catch((error) => {
        setMessageAlert({
          type: 'error',
          message: error?.data?.message || 'Error al actualizar el curso',
        });
        console.error(error);
      })
      .finally(() => setSubmitting(false));
  };
  const publishCourse = () => {
    if (submitting) {
      return;
    }
    setOpenModal(false);
    const payload = normalizeCoursePayload(course, mode, institutions);
    return mode === 'create' ? addCourse(payload) : updateCourse(payload);
  };

  const resolvedInstitution = resolveInstitution(
    course?.institution,
    institutions
  );
  const pillar = pillars.find((p) => Number(p.id) === Number(course?.pillar));

  return (
    <>
      <div className="wizard__form wizard__form--full" style={{ position: 'relative' }}>
        {submitting && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(255, 255, 255, 0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 5,
            }}
          >
            <Spinner style={{ width: 60, height: 60 }} />
          </div>
        )}
        {messageAlert && (
          <Alert type={messageAlert.type}>{messageAlert.message}</Alert>
        )}
        <CourseSummarySection
          course={course}
          institutions={institutions}
          institutionName={resolvedInstitution?.value}
          pillarName={pillar?.name}
          selectedInstitution={resolvedInstitution}
        />

        {openModal && (
          <ConfirmationModal
            header={renderTitle}
            title={
              mode === 'create'
                ? '¿Estás seguro que quieres crear el curso ?'
                : '¿Estás seguro que quieres editar el curso ?'
            }
            onClose={closeModal}
            open={openModal}
            handleAccept={publishCourse}
            handleDenied={closeModal}
          />
        )}

        <div className="wizard__action">
          <Button style={{ marginTop: '20px' }} variant="contained" type="button" secondary onClick={onPrev} disabled={submitting}>
            Volver
          </Button>
          <Button
            type="button"
            color="primary"
            onClick={modalOpen}
            variant="contained"
            style={{ marginTop: '20px' }}
            disabled={submitting}
          >
            {mode === 'create' ? 'Publicar Curso' : 'Actualizar Curso'}
          </Button>
        </div>
      </div>
    </>
  );
};


const normalizeCoursePayload = (course, mode, institutions = []) => {
  if (!course) {
    return {};
  }

  const normalizedInstitution = normalizeInstitutionForPayload(
    course.institution,
    institutions
  );

  const resolvedPillar =
    typeof course.pillar === 'object' && course.pillar !== null
      ? course.pillar.id
      : course.pillar;

  const institutionIdForPayload =
    typeof normalizedInstitution === 'object' && normalizedInstitution !== null
      ? normalizedInstitution.id
      : normalizedInstitution;

  const parsedInstitutionId =
    institutionIdForPayload !== undefined &&
    institutionIdForPayload !== null &&
    institutionIdForPayload !== '' &&
    !Number.isNaN(Number(institutionIdForPayload))
      ? Number(institutionIdForPayload)
      : institutionIdForPayload;

  const institutionId =
    parsedInstitutionId === undefined || parsedInstitutionId === null || parsedInstitutionId === ''
      ? institutions.find((inst) => {
          if (typeof normalizedInstitution === 'object' && normalizedInstitution !== null) {
            const normalizedName = normalizedInstitution.name || normalizedInstitution.value || '';
            const normalizedNameLower = normalizedName.toLowerCase().trim();
            const instName = inst.name ? inst.name.toLowerCase().trim() : '';
            const instValue = inst.value ? inst.value.toLowerCase().trim() : '';
            const instLabel = inst.label ? inst.label.toLowerCase().trim() : '';

            return (
              (instName && instName === normalizedNameLower) ||
              (instValue && instValue === normalizedNameLower) ||
              (instLabel && instLabel === normalizedNameLower)
            );
          }

          return false;
        })?.id
      : parsedInstitutionId;

  const institutionIdForRequest =
    institutionId !== undefined &&
    institutionId !== null &&
    institutionId !== '' &&
    !Number.isNaN(Number(institutionId))
      ? Number(institutionId)
      : institutionId;

  const payload = {
    ...course,
    slug: createCourseSlug(course.slug || course.name),
    pillar:
      resolvedPillar !== undefined && resolvedPillar !== null && resolvedPillar !== ''
        ? Number(resolvedPillar)
        : resolvedPillar,
    institution: institutionIdForRequest,
  };

  if (mode === 'edit' && course.id) {
    payload.id = course.id;
  }

  return payload;
};

const resolveInstitution = (institution, institutions) => {
  if (institution && typeof institution === 'object') {
    return {
      id: institution.id,
      value: institution.value || institution.name || '',
      logo: institution.logo,
    };
  }

  if (typeof institution === 'string') {
    const normalizedInstitutionName = institution.toLowerCase().trim();

    const matchByName = institutions?.find((inst) => {
      const instName = inst.name ? inst.name.toLowerCase().trim() : '';
      const instValue = inst.value ? inst.value.toLowerCase().trim() : '';
      const instLabel = inst.label ? inst.label.toLowerCase().trim() : '';

      return (
        instName === normalizedInstitutionName ||
        instValue === normalizedInstitutionName ||
        instLabel === normalizedInstitutionName
      );
    });

    if (matchByName) {
      return matchByName;
    }

    return {
      id: null,
      value: institution,
      logo: null,
    };
  }

  const match = institutions?.find(
    (inst) => Number(inst.id) === Number(institution)
  );

  if (match) {
    return match;
  }

  return null;
};

export default CourseSummary;
